<style scoped lang="scss">
.wrapper {
  margin: 0 auto 10px;
}
.breadcrumb {
  height: 45px;
  line-height: 45px;
  .el-breadcrumb {
    display: inline-block;
  }
}

.main {
  background: #fff;
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 20px 50px;
  color: #666666;
  .header {
  display: flex;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #999999;
  .back {
    margin-right: 20px;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -3px;
    }
    span {
      padding-left: 2px;
      &:hover {
        color: $color-theme;
      }
    }
  }
}
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 30px;
    border-radius: 6px;
    .step {
      margin: 0 60px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      opacity: 1;
      font-family: Source Han Sans SC;
      color: #aac9ff;
      .icon,
      .text {
        height: 30px;
        display: inline-block;
        line-height: 30px;
        vertical-align: middle;
      }

      .index {
        height: 22px;
        width: 22px;
        text-align: center;
        line-height: 22px;
        color: #fff;
        background: #bbd6ff;
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    .active {
      color: rgba(71, 142, 255, 1);
    }
    .dots {
      height: 30px;
      line-height: 30px;
      .dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: rgba(71, 142, 255, 1);
        border-radius: 50%;
        opacity: 1;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }
  .data-container {
    background-color: #fff;
  }
  .weight {
    .subject {
      display: inline-block;
      margin-right: 100px;
      margin-top: 10px;
    }
  }
  .source,
  .level {
    margin-top: 20px;
    .label {
      display: inline-block;
      .text {
        width: 80px;
        height: 24px;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
    }
  }
  .title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    .sub_title {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 24px;
      color: rgba(134, 152, 183, 1);
      opacity: 1;
    }
  }
  .class_num {
    display: inline-block;
    margin-right: 40px;
    margin-top: 10px;
    font-size: 14px;
  }
  .class_item {
    display: inline-block;
    width: 50px;
    text-align: center;
    color: #666666;
    height: 26px;
    line-height: 26px;
    margin-right: 5px;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
  }
  .class_item.active {
    background-color: #478eff;
    border-radius: 2px;
    color: #fff;
  }
  .level-area {
    .level + .level {
      margin-top: 15px;
    }
    .label,
    .item {
      display: inline-block;
      font-size: 14px;
    }
    .label {
      font-size: 16px;
    }
    .item {
      margin-top: 18px;
      .del-container {
        cursor: pointer;
        .el-icon-error {
          visibility: hidden;
        }
        &:hover .el-icon-error {
          visibility: visible;
        }
      }
    }
    .item + .item {
      margin-left: 15px;
    }
  }
}
</style>

<style lang="scss">
.task-list {
  .export-form {
    text-align: center;
    .el-dialog__body {
      padding: 20px 20px 0;
      h3 {
        text-align: center;
        font-size: $font-size-large;
        color: #333;
        margin: 25px 0;
      }
    }
    .el-dialog__footer {
      text-align: center !important;
    }
  }
}
</style>

<template>
  <div class="wrapper task-list">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/tool/classAssign/intro'}">精准教学分班</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tool/classAssign/list'}">精准教学分班汇总</el-breadcrumb-item>
        <el-breadcrumb-item>{{recordId?'编辑':'新增'}}记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main">
      <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="8" />
        <span>返回</span>
      </div>
    </header>
      <div class="top">
        <div class="step active">
          <span class="icon">
            <img style="height:30px" src="~images/check_icon.png" alt />
          </span>
          <span class="text">选择导入成绩成绩</span>
        </div>
        <div class="dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <div class="step">
          <span class="icon">
            <img style="height:30px" src="~images/check_icon.png" alt />
          </span>
          <span class="text active">设置规则</span>
        </div>
      </div>
      <div class="weight">
        <div class="title">
          <span>权重排序：</span>
        </div>
        <div class="item-container">
          <div class="subject" :key="i" v-for="(s,i) in DivideSettingVo.divideSubjects">
            <span>{{s.subjectName}}权重排名：</span>
            <!-- <draggable :group="'group'+i" v-model="s.divideSubjectItems" style="margin-top:10px;"> -->
            <span :key="d.id" v-for="(d,j) in s.divideSubjectItems">
              <el-tag size="small" :key="j">{{d.itemName}}</el-tag>
              <span v-if="j<s.divideSubjectItems.length-1">>&nbsp;</span>
            </span>
            <!-- </draggable> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title">
        <span>班级总人数：</span>
        <span class="sub_title">{{DivideSettingVo.totalStudNum}}&nbsp;人</span>
      </div>
      <div class="item-container">
        <div
          class="class_num"
          v-for="(d,i) in DivideSettingVo.divideStudClass"
          :key="i"
        >{{d.sourceName}}班：{{d.studNum}}人</div>
      </div>
    </div>
    <div class="main" :key="i" v-for="(r,i) in DivideSettingVo.divideRegionVos">
      <div class="title">
        <span>{{r.regionName}}：</span>
        <span class="sub_title">预计人数：{{totalNum[i]}}人</span>
      </div>
      <div class="source">
        <div class="label">
          <span class="icon">
            <img style="height:14px;" src="~images/person_icon.png" alt />
          </span>
          <span class="text">生源设置：</span>
        </div>
        <div
          class="class_item"
          :class="{'active':classSelected[i].indexOf(d.id) > -1}"
          v-for="(d,j) in DivideSettingVo.divideStudClass"
          :key="j"
          @click="toggleClassSelected(i,d,r)"
        >{{d.sourceName}}班</div>
      </div>
      <div class="level">
        <div class="label">
          <span class="icon">
            <img style="height:14px;" src="~images/level_icon.png" alt />
          </span>
          <span class="text">层级设置：</span>
        </div>
        <div class="class_num">
          <span>每班人数：</span>
          <el-input style="width:80px;" type="number" :min="1" v-model.number="classNum[i]"></el-input>
          <span>人</span>
        </div>
        <div class="level-area">

         <div class="level" v-if="taskType != 0">
            <div class="label">C+班：</div>
            <div class="item" v-if="c.type === 0" v-for="(c,j) in r.divideClassSettingVos" :key="j">
              <el-input
                v-if="c.editable"
                v-model="c.className"
                @keyup.enter="setClassNameDiable(c,false)"
                @blur="setClassNameDiable(c,false)"
                style="width:80px;color:#8698B7"
                placeholder="名称"
                clearable
              ></el-input>
              <span
                v-else
                style="cursor:pointer;color:#8698B7"
                @dblclick="setClassNameDiable(c,true)"
              >{{c.className}}</span>
              <el-input
                v-model.number="c.studNum"
                style="width:60px;color:#8698B7;"
                placeholder="人数"
              ></el-input>
              <el-input
                v-if="taskType == 2"
                v-model.number="c.rankingLimit"
                type="number"
                :min="0"
                style="width:160px;color:#8698B7;"
                placeholder="总分排名限制"
              ></el-input>
              <span class="del-container">
                <i class="el-icon-error" @click="deleteClass(i,j)"></i>
              </span>
            </div>
            <span v-if="plusIconVisible[i][3]">
              <i class="el-icon-circle-plus" @click="addClass(i,0)"></i>
            </span>
          </div>
          <div class="level">
            <div class="label">C班：</div>
            <div class="item" v-if="c.type === 3" v-for="(c,j) in r.divideClassSettingVos" :key="j">
              <el-input
                v-if="c.editable"
                v-model="c.className"
                @keyup.enter="setClassNameDiable(c,false)"
                @blur="setClassNameDiable(c,false)"
                style="width:80px;color:#8698B7"
                placeholder="名称"
                clearable
              ></el-input>
              <span
                v-else
                style="cursor:pointer;color:#8698B7"
                @dblclick="setClassNameDiable(c,true)"
              >{{c.className}}</span>
              <el-input
                v-model.number="c.studNum"
                style="width:60px;color:#8698B7;"
                placeholder="人数"
              ></el-input>
              <el-select multiple v-model="c.sourceNames" style="width:280px" placeholder="选择班级">
                <el-option
                  v-for="(c,k) in classObjSelected[i]"
                  :key="k"
                  :label="c.sourceName"
                  :value="c.sourceName"
                ></el-option>
              </el-select>
              <span class="del-container">
                <i class="el-icon-error" @click="deleteClass(i,j)"></i>
              </span>
            </div>
            <span v-if="plusIconVisible[i][2]">
              <i class="el-icon-circle-plus" @click="addClass(i,3)"></i>
            </span>
          </div>

           <div class="level">
            <div class="label">B班：</div>
            <div class="item" v-if="c.type === 2" v-for="(c,j) in r.divideClassSettingVos" :key="j">
              <el-input
                v-if="c.editable"
                v-model="c.className"
                @keyup.enter="setClassNameDiable(c,false)"
                @blur="setClassNameDiable(c,false)"
                style="width:80px;color:#8698B7"
                placeholder="名称"
                clearable
              ></el-input>
              <span
                v-else
                style="cursor:pointer;color:#8698B7"
                @dblclick="setClassNameDiable(c,true)"
              >{{c.className}}</span>
              <el-input
                v-model.number="c.studNum"
                style="width:60px;color:#8698B7;"
                placeholder="人数"
              ></el-input>
              <el-select multiple v-model="c.sourceNames" style="width:280px" placeholder="选择班级">
                <el-option
                  v-for="(c,k) in classObjSelected[i]"
                  :key="k"
                  :label="c.sourceName"
                  :value="c.sourceName"
                ></el-option>
              </el-select>
              <span class="del-container">
                <i class="el-icon-error" @click="deleteClass(i,j)"></i>
              </span>
            </div>
            <span v-if="plusIconVisible[i][1]">
              <i class="el-icon-circle-plus" @click="addClass(i,2)"></i>
            </span>
          </div>
           <div class="level">
            <div class="label">A班：</div>
            <div class="item" v-if="c.type === 1" v-for="(c,j) in r.divideClassSettingVos" :key="j">
              <el-input
                v-if="c.editable"
                v-model="c.className"
                @keyup.enter="setClassNameDiable(c,false)"
                @blur="setClassNameDiable(c,false)"
                style="width:80px;color:#8698B7"
                placeholder="名称"
                clearable
              ></el-input>
              <span
                v-else
                style="cursor:pointer;color:#8698B7"
                @dblclick="setClassNameDiable(c,true)"
              >{{c.className}}</span>
              <el-input
                v-model.number="c.studNum"
                style="width:60px;color:#8698B7;"
                placeholder="人数"
              ></el-input>
              <el-select multiple v-model="c.sourceNames" style="width:280px" placeholder="选择班级">
                <el-option
                  v-for="(c,k) in classObjSelected[i]"
                  :key="k"
                  :label="c.sourceName"
                  :value="c.sourceName"
                ></el-option>
              </el-select>
              <span class="del-container">
                <i class="el-icon-error" @click="deleteClass(i,j)"></i>
              </span>
            </div>
            <span v-if="plusIconVisible[i][0]">
              <i class="el-icon-circle-plus" @click="addClass(i,1)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title">
        <span>设置跨区班级：</span>
      </div>
      <div style="margin-top:10px">
        <el-checkbox v-model="crossRegionClassSetting1.checked">C5</el-checkbox>
        <el-input
          placeholder="学生人数"
          size="mini"
          style="width:100px;margin-left:10px;"
          v-model="crossRegionClassSetting1.studNum"
        ></el-input>
        <el-select
          placeholder="选择分区"
          size="mini"
          style="width:100px;margin-left:20px"
          v-model="crossRegionClassSetting1.regionName"
        >
          <el-option label="分区一" value="分区一"></el-option>
          <el-option label="分区二" value="分区二"></el-option>
        </el-select>
        <span style="margin-left:20px">跨区人数</span>
        <el-input
          placeholder="跨区人数"
          size="mini"
          style="width:100px"
          min="0"
          :max="crossRegionClassSetting1.studNum"
          type="number"
          v-model.number="crossRegionClassSetting1.crossRegionStudNum"
        ></el-input>
      </div>
      <div style="margin-top:10px">
        <el-checkbox v-model="crossRegionClassSetting2.checked">A-</el-checkbox>
        <el-input
          placeholder="学生人数"
          size="mini"
          style="width:100px;margin-left:10px;"
          v-model="crossRegionClassSetting2.studNum"
        ></el-input>
        <el-select
          placeholder="选择分区"
          size="mini"
          style="width:100px;margin-left:20px"
          v-model="crossRegionClassSetting2.regionName"
        >
          <el-option label="分区一" value="分区一"></el-option>
          <el-option label="分区二" value="分区二"></el-option>
        </el-select>
        <span style="margin-left:20px">跨区人数</span>
        <el-input
          placeholder="跨区人数"
          size="mini"
          style="width:100px"
          min="0"
          :max="crossRegionClassSetting2.studNum"
          type="number"
          v-model.number="crossRegionClassSetting2.crossRegionStudNum"
        ></el-input>
      </div>
      <div style="text-align:center;margin-top:30px;">
        <el-button
          type="primary"
          style="padding-left:15px;padding-right:15px;"
          @click="checkSettingSubmit"
        >生成分班</el-button>
      </div>
    </div>
    <yue-dialog title="生成分班" :visible.sync="dialogVisible" width="30%">
      <el-form @submit.native.prevent label-position="right" label-width="100px">
        <el-form-item label="记录名称：">
          <el-input placeholder="请输入记录名称" v-model="DivideSettingVo.recordName"></el-input>
        </el-form-item>
        <el-form-item label="类型：" v-if="recordId">
          <el-radio-group v-model="changeType">
            <el-radio :label="0">创建新记录</el-radio>
            <el-radio :label="1">修改原记录</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="margin-top:50px;text-align:center">
        <el-button size="small" type="primary" @click="setDivideSetting">确定</el-button>
      </div>
    </yue-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDivideSetting, setDivideSetting } from "@/api/tool";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      taskType:0,
      changeType: 1,
      crossRegionClassSetting1: {
        checked: false,
        className: "C5",
        crossRegionStudNum: "",
        recordId: "",
        regionName: "",
        studNum: "",
        taskId: "",
        type: 1
      },
      crossRegionClassSetting2: {
        checked: false,
        className: "A-",
        crossRegionStudNum: "",
        recordId: "",
        regionName: "",
        studNum: "",
        taskId: "",
        type: 2
      },
      taskName: "",
      dialogVisible: false,
      classSelected: [[], []],
      classObjSelected: [[], []],
      classNum: [0, 0],
      taskId: "",
      recordId: "",
      aClassChecked: [],
      bClassChecked: [],
      cClassChecked: [],
      fileList: [],
      DivideSettingVo: {
        taskId: "",
        recordId: "",
        recordName: "",
        totalStudNum: "",
        divideCrossRegionSettings: [],
        divideSubjects: [
          {
            id: "",
            taskId: "",
            subjectName: "",
            divideSubjectItems: [
              {
                id: "",
                divideId: "",
                divideSubjectId: "",
                itemName: "",
                orderNum: 0
              }
            ]
          }
        ],
        divideStudClass: [],
        divideRegionVos: [
          {
            taskId: "",
            regionName: "",
            divideRegionSourceSettings: [],
            divideClassSettingVos: []
          },
          {
            taskId: "",
            regionName: "",
            divideRegionSourceSettings: [],
            divideClassSettingVos: []
          }
        ]
      }
    };
  },
  mounted() {
    this.schoolId = this.userInfo.schoolId;
    this.taskId = this.$route.query.taskId;
    this.taskName = this.$route.query.taskName;
    this.recordId = this.$route.query.recordId || "";
    this.changeType = this.recordId ? 1 : 0;
    this.getSetting();
  },
  components: {
    draggable
  },
  methods: {
    toggleClassSelected(i, c, r) {
      if (this.classSelected[i].indexOf(c.id) > -1) {
        let index = this.classSelected[i].indexOf(c.id);
        this.classSelected[i].splice(index, 1);
        this.classObjSelected[i].splice(index, 1);
        for (let k = 0; k < 3; k++) {
          if (r.divideClassSettingVos[k]) {
            if (
              r.divideClassSettingVos[k].sourceNames.indexOf(c.sourceName) > -1
            ) {
              index = r.divideClassSettingVos[k].sourceNames.indexOf(
                c.sourceName
              );
              r.divideClassSettingVos[k].sourceNames.splice(index, 1);
            }
          }
        }
      } else {
        this.classSelected[i].push(c.id);
        this.classObjSelected[i].push(c);
      }
    },
    setClassNameDiable(c, bool) {
      if (c.className != "") {
        c["editable"] = bool;
      }
    },
    deleteClass(i, j) {
      this.DivideSettingVo.divideRegionVos[i].divideClassSettingVos.splice(
        j,
        1
      );
    },
    addClass(index, type) {
      let letterList = ["C", "A", "B", "C"];
      let arr1 = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
        c => {
          if (type == 0 || type == 3) {
            return c.type == 0 || c.type == 3;
          } else {
            return c.type == type;
          }
        }
      );
      let arr2 = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
        c =>{
          if (type == 0 || type == 3) {
            return c.type == 0 || c.type == 3;
          } else {
            return c.type == type;
          }
        }
      );
      let len = arr1.length + arr2.length;
      this.DivideSettingVo.divideRegionVos[index].divideClassSettingVos.push({
        taskId: this.taskId,
        recordId: this.recordId,
        type: type,
        rankingLimit:'',
        sourceNames: [],
        className: letterList[type] + (len + 1),
        studNum: this.classNum[index],
        editable: false,
        regionIndex: index
      });
    },
    async getSetting() {
      let res = await getDivideSetting({
        taskId: this.taskId,
        recordId: this.recordId
      });
      if (res.code == 200) {
        this.taskType = res.result.taskType
        this.DivideSettingVo = res.result;
        this.DivideSettingVo.recordName = this.$route.query.recordName || "";
        res.result.divideCrossRegionSettings.map(c => {
          if (c.type == 1) {
            this.crossRegionClassSetting1 = {
              checked: true,
              ...c
            };
          }
          if (c.type == 2) {
            this.crossRegionClassSetting2 = {
              checked: true,
              ...c
            };
          }
        });
        if (this.DivideSettingVo.divideRegionVos.length == 0) {
          this.$set(this.DivideSettingVo, "divideRegionVos", [
            {
              regionName: "分区一",
              divideRegionSourceSettings: [],
              divideClassSettingVos: []
            },
            {
              regionName: "分区二",
              divideRegionSourceSettings: [],
              divideClassSettingVos: []
            }
          ]);
        } else {
          this.classSelected[0] = this.DivideSettingVo.divideRegionVos[0].divideRegionSourceSettings.map(
            d => d.classId
          );
          this.classSelected[1] = this.DivideSettingVo.divideRegionVos[1].divideRegionSourceSettings.map(
            d => d.classId
          );
          this.DivideSettingVo.divideStudClass.map(d => {
            if (this.classSelected[0].indexOf(d.id) > -1) {
              this.classObjSelected[0].push(d);
            }
            if (this.classSelected[1].indexOf(d.id) > -1) {
              this.classObjSelected[1].push(d);
            }
          });
        }
      }
    },
    checkSettingSubmit() {
      // 判断每个区的人数之和是否等于总人数
      let total = 0;
      if (this.crossRegionClassSetting1.checked) {
        total += Number(this.crossRegionClassSetting1.studNum);
      }
      if (this.crossRegionClassSetting2.checked) {
        total += Number(this.crossRegionClassSetting2.studNum);
      }

      if (
        this.totalNum[0] + this.totalNum[1] + total !=
        this.DivideSettingVo.totalStudNum
      ) {
        return this.$message.warning("分区人数之和不等于总人数");
      }
      // 判断班级是否选择正确（要选满，不交叉，每个区至少要选一个）
      if (
        this.classSelected[0].length == 0 ||
        this.classSelected[1].length == 0
      ) {
        return this.$message.warning("存在分区生源设置未选择班级");
      }
      let aIsInB = this.classSelected[0].some(c => {
        return this.classSelected[1].indexOf(c) > -1;
      });
      let bIsInA = this.classSelected[1].some(c => {
        return this.classSelected[0].indexOf(c) > -1;
      });
      if (aIsInB || bIsInA) {
        return this.$message.warning("两个分区生源设置班级选择存在重复");
      }
      if (
        this.classSelected[0].length + this.classSelected[1].length !=
        this.DivideSettingVo.divideStudClass.length
      ) {
        return this.$message.warning("分区生源设置存在未选的班级");
      }

      //校验分区一内容
      let region1 = this.DivideSettingVo.divideRegionVos[0];
      let divideClassSettingVos = region1.divideClassSettingVos;

      let divideClassSettingVosA = divideClassSettingVos.filter(
        c => c.type == 1
      );
      let divideClassSettingVosB = divideClassSettingVos.filter(
        c => c.type == 2
      );
      let divideClassSettingVosC = divideClassSettingVos.filter(
        c => c.type == 3
      );
      let divideClassSettingVosCPlus = divideClassSettingVos.filter(
        c => c.type == 0
      );

      if (divideClassSettingVosA.length == 1) {
        if (
          divideClassSettingVosA[0].sourceNames.length > 0 &&
          divideClassSettingVosA[0].sourceNames.length <
            this.classSelected[0].length
        ) {
          return this.$message.warning("分区一A等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosA.length == 2) {
        if (
          divideClassSettingVosA[0].sourceNames.length == 0 &&
          divideClassSettingVosA[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosA[0].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosA[1].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosA[0].sourceNames.length +
            divideClassSettingVosA[1].sourceNames.length ==
            this.classSelected[0].length
        ) {
          aIsInB = divideClassSettingVosA[0].sourceNames.some(c => {
            return divideClassSettingVosA[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosA[1].sourceNames.some(c => {
            return divideClassSettingVosA[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区一A等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区一A等级班级选择有误");
        }
      }

      if (divideClassSettingVosB.length == 1) {
        if (
          divideClassSettingVosB[0].sourceNames.length > 0 &&
          divideClassSettingVosB[0].sourceNames.length <
            this.classSelected[0].length
        ) {
          return this.$message.warning("分区一B等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosB.length == 2) {
        if (
          divideClassSettingVosB[0].sourceNames.length == 0 &&
          divideClassSettingVosB[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosB[0].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosB[1].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosB[0].sourceNames.length +
            divideClassSettingVosB[1].sourceNames.length ==
            this.classSelected[0].length
        ) {
          aIsInB = divideClassSettingVosB[0].sourceNames.some(c => {
            return divideClassSettingVosB[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosB[1].sourceNames.some(c => {
            return divideClassSettingVosB[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区一B等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区一B等级班级选择有误");
        }
      }

      if (divideClassSettingVosC.length == 1) {
        if (
          divideClassSettingVosC[0].sourceNames.length > 0 &&
          divideClassSettingVosC[0].sourceNames.length <
            this.classSelected[0].length
        ) {
          return this.$message.warning("分区一C等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosC.length == 2) {
        if (
          divideClassSettingVosC[0].sourceNames.length == 0 &&
          divideClassSettingVosC[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosC[0].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosC[1].sourceNames.length <
            this.classSelected[0].length &&
          divideClassSettingVosC[0].sourceNames.length +
            divideClassSettingVosC[1].sourceNames.length ==
            this.classSelected[0].length
        ) {
          aIsInB = divideClassSettingVosC[0].sourceNames.some(c => {
            return divideClassSettingVosC[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosC[1].sourceNames.some(c => {
            return divideClassSettingVosC[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区一C等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区一C等级班级选择有误");
        }
      }
      if(divideClassSettingVosCPlus.length == 1){
        if(this.taskType == 2 && divideClassSettingVosCPlus[0].rankingLimit == ''){
          return this.$message.warning('总分排名限制不能为空')
        }
      }
      let ifNullString = false
      divideClassSettingVosA.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      divideClassSettingVosB.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      divideClassSettingVosC.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      if(ifNullString){
          return this.$message.warning('班级人数不能为空')
      }

      //校验分区二内容
      let region2 = this.DivideSettingVo.divideRegionVos[1];
      divideClassSettingVos = region2.divideClassSettingVos;

      divideClassSettingVosA = divideClassSettingVos.filter(c => c.type == 1);
      divideClassSettingVosB = divideClassSettingVos.filter(c => c.type == 2);
      divideClassSettingVosC = divideClassSettingVos.filter(c => c.type == 3);
      divideClassSettingVosCPlus = divideClassSettingVos.filter(
        c => c.type == 0
      );
      if (divideClassSettingVosA.length == 1) {
        if (
          divideClassSettingVosA[0].sourceNames.length > 0 &&
          divideClassSettingVosA[0].sourceNames.length <
            this.classSelected[1].length
        ) {
          return this.$message.warning("分区二A等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosA.length == 2) {
        if (
          divideClassSettingVosA[0].sourceNames.length == 0 &&
          divideClassSettingVosA[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosA[0].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosA[1].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosA[0].sourceNames.length +
            divideClassSettingVosA[1].sourceNames.length ==
            this.classSelected[1].length
        ) {
          aIsInB = divideClassSettingVosA[0].sourceNames.some(c => {
            return divideClassSettingVosA[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosA[1].sourceNames.some(c => {
            return divideClassSettingVosA[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区二A等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区二A等级班级选择有误");
        }
      }

      if (divideClassSettingVosB.length == 1) {
        if (
          divideClassSettingVosB[0].sourceNames.length > 0 &&
          divideClassSettingVosB[0].sourceNames.length <
            this.classSelected[1].length
        ) {
          return this.$message.warning("分区二B等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosB.length == 2) {
        if (
          divideClassSettingVosB[0].sourceNames.length == 0 &&
          divideClassSettingVosB[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosB[0].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosB[1].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosB[0].sourceNames.length +
            divideClassSettingVosB[1].sourceNames.length ==
            this.classSelected[1].length
        ) {
          aIsInB = divideClassSettingVosB[0].sourceNames.some(c => {
            return divideClassSettingVosB[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosB[1].sourceNames.some(c => {
            return divideClassSettingVosB[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区二B等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区二B等级班级选择有误");
        }
      }
      if (divideClassSettingVosC.length == 1) {
        if (
          divideClassSettingVosC[0].sourceNames.length > 0 &&
          divideClassSettingVosC[0].sourceNames.length <
            this.classSelected[1].length
        ) {
          return this.$message.warning("分区二C等级班级须全选或不选");
        }
      }
      if (divideClassSettingVosC.length == 2) {
        if (
          divideClassSettingVosC[0].sourceNames.length == 0 &&
          divideClassSettingVosC[1].sourceNames.length == 0
        ) {
        } else if (
          divideClassSettingVosC[0].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosC[1].sourceNames.length <
            this.classSelected[1].length &&
          divideClassSettingVosC[0].sourceNames.length +
            divideClassSettingVosC[1].sourceNames.length ==
            this.classSelected[1].length
        ) {
          aIsInB = divideClassSettingVosC[0].sourceNames.some(c => {
            return divideClassSettingVosC[1].sourceNames.indexOf(c) > -1;
          });
          bIsInA = divideClassSettingVosC[1].sourceNames.some(c => {
            return divideClassSettingVosC[0].sourceNames.indexOf(c) > -1;
          });
          if (aIsInB || bIsInA) {
            return this.$message.warning("分区二C等级班级选择存在重复");
          }
        } else {
          return this.$message.warning("分区二C等级班级选择有误");
        }
      }
      ifNullString = false
      divideClassSettingVosA.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      divideClassSettingVosB.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      divideClassSettingVosC.map(d=>{
        if(d.studNum == ''){
          ifNullString = true
        }
      })
      if(ifNullString){
          return this.$message.warning('班级人数不能为空')
      }

      if(divideClassSettingVosCPlus.length == 1){
        if(this.taskType == 2 && divideClassSettingVosCPlus[0].rankingLimit == ''){
          return this.$message.warning('总分排名限制不能为空')
        }
      }
      if (this.crossRegionClassSetting1.checked) {
        this.crossRegionClassSetting1.taskId = this.taskId;
        this.crossRegionClassSetting1.recordId = this.recordId;
        if (!this.crossRegionClassSetting1.studNum) {
          return this.$message.warning("C5班请输入学生人数");
        }
        if (!this.crossRegionClassSetting1.regionName) {
          return this.$message.warning("C5班请选择分区");
        }
        if (!this.crossRegionClassSetting1.crossRegionStudNum) {
          return this.$message.warning("C5班请输入跨区人数");
        }
        if (
          this.crossRegionClassSetting1.crossRegionStudNum >
          this.crossRegionClassSetting1.studNum
        ) {
          return this.$message.warning("C5班跨区人数不能超过学生人数");
        }
      }
      if (this.crossRegionClassSetting2.checked) {
        this.crossRegionClassSetting2.taskId = this.taskId;
        this.crossRegionClassSetting2.recordId = this.recordId;
        if (!this.crossRegionClassSetting2.studNum) {
          return this.$message.warning("A-班请输入学生人数");
        }
        if (!this.crossRegionClassSetting2.regionName) {
          return this.$message.warning("A-班请选择分区");
        }
        if (!this.crossRegionClassSetting2.crossRegionStudNum) {
          return this.$message.warning("A-班请输入跨区人数");
        }
        if (
          this.crossRegionClassSetting2.crossRegionStudNum >
          this.crossRegionClassSetting2.studNum
        ) {
          return this.$message.warning("A-班跨区人数不能超过学生人数");
        }
      }

      let classList = this.DivideSettingVo.divideStudClass;
      let classSelectedList1 = classList.filter(c => {
        return this.classSelected[0].indexOf(c.id) > -1;
      });
      this.DivideSettingVo.divideRegionVos[0].divideRegionSourceSettings = [];
      classSelectedList1.map(c => {
        this.DivideSettingVo.divideRegionVos[0].divideRegionSourceSettings.push(
          {
            classId: c.id,
            id: "",
            recordId: "",
            sourceName: c.sourceName,
            taskId: this.taskId
          }
        );
      });
      let classSelectedList2 = classList.filter(c => {
        return this.classSelected[1].indexOf(c.id) > -1;
      });
      this.DivideSettingVo.divideRegionVos[1].divideRegionSourceSettings = [];
      classSelectedList2.map(c => {
        this.DivideSettingVo.divideRegionVos[1].divideRegionSourceSettings.push(
          {
            classId: c.id,
            id: "",
            recordId: "",
            sourceName: c.sourceName,
            taskId: this.taskId
          }
        );
      });
      //设置各学科权重
      // this.DivideSettingVo.divideSubjects[0].divideSubjectItems = this.DivideSettingVo.divideSubjects[0].divideSubjectItems.map(
      //   (w, i) => {
      //     w.orderNum = i;
      //     return w;
      //   }
      // );
      // this.DivideSettingVo.divideSubjects[1].divideSubjectItems = this.DivideSettingVo.divideSubjects[1].divideSubjectItems.map(
      //   (w, i) => {
      //     w.orderNum = i;
      //     return w;
      //   }
      // );
      this.DivideSettingVo.divideCrossRegionSettings = [];
      if (this.crossRegionClassSetting1.checked) {
        this.DivideSettingVo.divideCrossRegionSettings.push(
          this.crossRegionClassSetting1
        );
      }
      if (this.crossRegionClassSetting2.checked) {
        this.DivideSettingVo.divideCrossRegionSettings.push(
          this.crossRegionClassSetting2
        );
      }
      this.DivideSettingVo.divideRegionVos[0].taskId = this.taskId;
      this.DivideSettingVo.divideRegionVos[1].taskId = this.taskId;
      this.DivideSettingVo.taskId = this.taskId;
      this.DivideSettingVo.schoolId = this.schoolId;
      this.DivideSettingVo.recordId = this.recordId;
      this.dialogVisible = true;
    },
    async setDivideSetting() {
      if (
        this.DivideSettingVo.recordName == "" ||
        this.DivideSettingVo.recordName.trim() == ""
      ) {
        return this.$message.warning("请输入记录名称");
      }
      this.DivideSettingVo.type = this.changeType;
      let res = await setDivideSetting(this.DivideSettingVo);
      if (res.code == 200) {
        this.$message.success(this.changeType ? "更新成功" : "创建成功");
        this.$router.replace(
          "/tool/classAssign/record?taskId=" +
            res.result.taskId +
            "&taskName=" +
            this.taskName
        );
      } else {
        this.$message.error(res.message);
      }
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    // aClassList() {
    //   let list1 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 1) {
    //     list1 = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
    //       c => c.type === 1
    //     );
    //   }
    //   let list2 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 2) {
    //     list2 = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
    //       c => c.type === 1
    //     );
    //   }
    //   return [...list1, ...list2];
    // },
    // bClassList() {
    //   let list1 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 1) {
    //     list1 = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
    //       c => c.type === 2
    //     );
    //   }
    //   let list2 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 2) {
    //     list2 = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
    //       c => c.type === 2
    //     );
    //   }
    //   if (list1.length < 2) {
    //     list1 = [];
    //   }
    //   if (list2.length < 2) {
    //     list2 = [];
    //   }
    //   return [...list1, ...list2];
    // },
    // cClassList() {
    //   let list1 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 1) {
    //     list1 = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
    //       c => c.type === 3
    //     );
    //   }
    //   let list2 = [];
    //   if (this.DivideSettingVo.divideRegionVos.length >= 2) {
    //     list2 = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
    //       c => c.type === 3
    //     );
    //   }
    //   if (list1.length < 2) {
    //     list1 = [];
    //   }
    //   if (list2.length < 2) {
    //     list2 = [];
    //   }
    //   return [...list1, ...list2];
    // },
    totalNum() {
      let arr = [0, 0];
      if (this.DivideSettingVo.divideRegionVos.length >= 1) {
        this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.map(c => {
          arr[0] += parseInt(c.studNum) || 0;
        });
      }
      if (this.DivideSettingVo.divideRegionVos.length >= 2) {
        this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.map(c => {
          arr[1] += parseInt(c.studNum) || 0;
        });
      }
      return arr;
    },
    plusIconVisible() {
      let plusIconVisible = [
        [true, true, true, true],
        [true, true, true, true]
      ];
      if (this.DivideSettingVo.divideRegionVos.length == 0) {
        return plusIconVisible;
      }
      let arr = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
        c => c.type == 1
      );
      if (arr.length >= 2) {
        plusIconVisible[0][0] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
        c => c.type == 2
      );
      if (arr.length >= 2) {
        plusIconVisible[0][1] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
        c => c.type == 3
      );
      if (arr.length >= 2) {
        plusIconVisible[0][2] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[0].divideClassSettingVos.filter(
        c => c.type == 0
      );
      if (arr.length >= 1) {
        plusIconVisible[0][3] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
        c => c.type == 1
      );
      if (arr.length >= 2) {
        plusIconVisible[1][0] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
        c => c.type == 2
      );
      if (arr.length >= 2) {
        plusIconVisible[1][1] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
        c => c.type == 3
      );
      if (arr.length >= 2) {
        plusIconVisible[1][2] = false;
      }
      arr = this.DivideSettingVo.divideRegionVos[1].divideClassSettingVos.filter(
        c => c.type == 0
      );
      if (arr.length >= 2) {
        plusIconVisible[1][3] = false;
      }
      return plusIconVisible;
    }
  }
};
</script>
